import React from 'react';

// Shared with Town Budget, the reference layout for report pages.
export const REPORT_HEADER_CLASS = 'flex flex-wrap items-center justify-between gap-3 mb-2 border-b border-gray-300 pb-2';
export const REPORT_TITLE_CLASS = 'text-2xl font-bold text-gray-900';
export function ReportPageHeader({title,description,actions,headingAs:Heading='h1',editorial=false}) {
  return <header className={editorial ? 'flex flex-wrap items-end justify-between gap-4 border-b-[12px] border-[#243f86] pb-5' : REPORT_HEADER_CLASS}>
    <div className="min-w-0"><Heading className={editorial ? 'text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl' : REPORT_TITLE_CLASS}>{title}</Heading>{description&&<p className="mt-2 text-sm text-gray-600">{description}</p>}</div>
    {actions&&<div className="flex flex-wrap items-center gap-3">{actions}</div>}
  </header>;
}
export function ReportPage({title,description,actions,children,editorial=false,banner,bannerAlt=''}) {
  return <div className="min-h-screen bg-base-200 text-base-content flex flex-col">
    <div className="flex flex-1 w-full justify-center"><div className="w-full max-w-screen-2xl">
      <section className="card bg-base-100 shadow-xl rounded-xl mb-6 w-full"><div className="px-1 py-2 sm:px-6 sm:py-4"><div className={editorial ? 'space-y-8 sm:space-y-10' : 'space-y-6'}>
        <div className={banner ? 'space-y-3 sm:space-y-4' : undefined}>
          {banner && <img src={banner} alt={bannerAlt} className="h-auto w-full object-contain" />}
          <ReportPageHeader title={title} description={editorial ? undefined : description} actions={actions} editorial={editorial}/>
        </div>
        {editorial && description && <p className="max-w-5xl text-base leading-7 text-slate-600">{description}</p>}
        {children}
      </div></div></section>
    </div></div>
  </div>;
}

export function ReportSectionHeader({children,headingAs:Heading='h2'}) {
  return <Heading className="bg-gray-100 border border-gray-200 rounded p-2 text-lg font-semibold text-gray-900">{children}</Heading>;
}

// Open chapter headings for report content outside collapsible sections.
export function ReportChapterHeader({title,description,tone='blue',image,imageAlt='',headingAs:Heading='h3'}) {
  const tones = {blue: 'bg-[#243f86]', lavender: 'bg-[#9b89d9]', orange: 'bg-[#eb9148]', green: 'bg-[#6d9b78]', teal: 'bg-[#388899]', rose: 'bg-[#bc6487]'};
  return <header className="pt-4 pb-2 sm:pt-6">
    <Heading className="text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">{title}</Heading>
    <div className={`mt-4 h-3 w-full ${tones[tone] || tones.blue}`} aria-hidden="true" />
    {image && <img src={image} alt={imageAlt} className="mt-5 h-auto w-full object-contain" loading="lazy" />}
    {description && <p className="mt-5 max-w-4xl text-base leading-7 text-slate-600">{description}</p>}
  </header>;
}
